import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { FormMultiSelect } from '../../fields/FormMultiSelect';
import { getRequiredValidator, isFieldOptional, isSearchableExtDictionary } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderMultiChoiceField(ctx: FieldMapperContext): React.ReactElement {
  const { ctField, fieldLabel, choices, fieldDisabled, isLoading, onChange, onFilterChange } = ctx;

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={FormMultiSelect}
      choices={choices}
      defaultValue={ctField.defaultValue}
      label={fieldLabel}
      validator={getRequiredValidator(ctField)}
      optional={isFieldOptional(ctField)}
      onFilterChange={
        isSearchableExtDictionary(ctField) ? (value: string) => onFilterChange?.(value) : undefined
      }
      onSelectionChange={(value: any) => onChange?.(value)}
      disabled={fieldDisabled}
      isLoading={isLoading}
    />
  );
}
